module.exports = __webpack_public_path__ + "media/Video 33.22196afe.mp4";